import { useEffect, useRef, useState } from 'react';
import debounce from 'react-utils/debounce';
import UIAbstractFloaty from 'UIComponents/tooltip/UIAbstractFloaty';
import { UITourPulserAnimate } from './UITourPulserElements';
import { PulserSpotlight } from './PulserSpotlight';
import { getAbsoluteRect } from '../utils/elementUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UITourPulserSpotlight = ({
  className,
  borderColor,
  borderSize,
  borderShadowId,
  enableBorder,
  pulserContainer,
  pulserDistance,
  pulserDuration,
  pulserPadding,
  pulserRadius,
  pulserRef,
  pulserTarget
}) => {
  const floatyRef = useRef(null);
  const [pulserPath, setPulserPath] = useState();
  const pulserSpotlightRef = useRef();

  /**
   * UIAbstractFloaty is monitoring resize and scroll events to reposition the pulser
   * but the target element may have moved because the loading of other parts of the page
   * The effect is observing DOM changes to reposition the pulser when the target element moves
   */
  useEffect(() => {
    const observer = new MutationObserver(debounce(() => {
      const {
        reposition
      } = floatyRef.current || {};
      const {
        current: currentPulserSpotlight
      } = pulserSpotlightRef;
      if (typeof reposition === 'function' && currentPulserSpotlight && !currentPulserSpotlight.equalsRect(getAbsoluteRect(pulserTarget))) {
        reposition();
      }
    }, 50));
    observer.observe(document.body, {
      subtree: true,
      childList: true
    });
    return () => observer.disconnect();
  }, [pulserTarget]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIAbstractFloaty, {
      bodyElement: pulserContainer,
      content: null,
      target: pulserTarget
      // @ts-expect-error dependency missing types
      ,
      computePosition: ({
        targetBounds
      }) => {
        const prevPulserSpotlight = pulserSpotlightRef.current;
        const newPulserSpotlight = new PulserSpotlight(pulserTarget, {
          distance: pulserDistance,
          padding: pulserPadding,
          radius: pulserRadius
        });
        if (!newPulserSpotlight.equals(prevPulserSpotlight)) {
          const newPulserPath = newPulserSpotlight.generatePulserPath();
          pulserSpotlightRef.current = newPulserSpotlight;
          setPulserPath(newPulserPath);
          const {
            repositionPulserOverlay
          } = pulserRef.current || {};
          if (typeof repositionPulserOverlay === 'function') {
            const {
              pulserPath: oldPulserPath
            } = prevPulserSpotlight || {};
            repositionPulserOverlay(newPulserPath, oldPulserPath);
          }
        }
        return targetBounds;
      }
      // @ts-expect-error ref does not have types
      ,
      ref: floatyRef
    }), enableBorder && pulserPath && /*#__PURE__*/_jsx("path", {
      className: className,
      d: pulserPath.start,
      fill: "none",
      filter: `url(#${borderShadowId})`,
      stroke: borderColor,
      strokeWidth: borderSize,
      children: pulserPath.end && /*#__PURE__*/_jsx(UITourPulserAnimate, {
        duration: pulserDuration,
        values: `${pulserPath.start};${pulserPath.end};${pulserPath.start}`
      })
    })]
  });
};
export default UITourPulserSpotlight;